<template>
  <div class="document-container">
    <div v-if="!isRetired">
      <div class="columns">
        <div class="column">
          <person-profile-master-record-highlights
            :isRetired="isRetired"
            :person="person"
          />
        </div>
        <div
          v-if="hasModule('PRSID:PRPRF:PROFILE:VIEW') && hasModule('PRSID:MATCH:RESOLVENM:VIEW')"
          class="column"
        >
          <person-profile-pid-pending-near-match-overview
            :id="id"
            :isRetired="isRetired"
            :nearMatches="pidNearMatches"
            :totalCount="pidNearMatchTotalCount"
          />
        </div>
        <div
          v-if="hasModule('DRMCH:PRPRF:PROFILE:VIEW') && hasModule('DRMCH:MATCH:RESOLVENM:VIEW')"
          class="column"
        >
          <dm-pending-near-match-overview
            :id="id"
            :isRetired="isRetired"
            :nearMatches="dmNearMatches"
            :totalCount="dmNearMatchTotalCount"
          />
        </div>
      </div>
      <div class="columns">
        <div
          v-if="hasModule('PRSID:PRPRF:PROFILE:VIEW')
            && (hasModule('PRSID:PRPRF:NOTES:VIEW:GENERAL')
              || hasModule('PRSID:PRPRF:NOTES:VIEW:ADMIN'))"
          class="column"
        >
          <person-profile-recent-notes-overview
            :id="id"
            :isRetired="isRetired"
          />
        </div>
        <div
          v-if="hasModule('PRSID:PRPRF:PROFILE:VIEW')"
          class="column"
        >
          <person-profile-alias-id-overview
            :id="id"
            :isRetired="isRetired"
            :aliasIds="aliasIds"
            :person="person"
          />
        </div>
        <div
          v-if="hasModule('PRSID:PRPRF:PROFILE:VIEW')"
          class="column"
        >
          <person-profile-recent-history-overview
            :id="id"
            :isRetired="isRetired"
            :person="person"
            :recentHistoryRecords="recentHistoryRecords"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <pid-retired-id-panel
        v-if="isRetired"
        :person="person"
      />
      <div class="columns">
        <div class="column">
          <person-profile-master-record-highlights
            :isRetired="isRetired"
            :person="person"
          />
        </div>
        <div class="column">
          <person-profile-alias-id-overview
            :id="id"
            :isRetired="isRetired"
            :aliasIds="aliasIds"
            :person="person"
          />
        </div>
        <div class="column">
          <person-profile-recent-history-overview
            :id="id"
            :isRetired="isRetired"
            :person="person"
            :recentHistoryRecords="recentHistoryRecords"
          />
        </div>
      </div>
      <div class="columns">
        <div
          class="column is-one-third"
          v-if="hasModule('PRSID:PRPRF:PROFILE:VIEW')
            && (hasModule('PRSID:PRPRF:NOTES:VIEW:GENERAL')
              || hasModule('PRSID:PRPRF:NOTES:VIEW:ADMIN'))"
        >
          <person-profile-recent-notes-overview
            :id="id"
            :isRetired="isRetired"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DmPendingNearMatchOverview from '@/components/DmPendingNearMatchOverview.vue';
import PersonProfileMasterRecordHighlights from '@/components/PersonProfileMasterRecordHighlights.vue';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';
import PersonProfilePidPendingNearMatchOverview from '@/components/PersonProfilePidPendingNearMatchOverview.vue';
import PersonProfileRecentNotesOverview from '@/components/PersonProfileRecentNotesOverview.vue';
import PersonProfileAliasIdOverview from '@/components/PersonProfileAliasIdOverview.vue';
import PersonProfileRecentHistoryOverview from '@/components/PersonProfileRecentHistoryOverview.vue';
import PidRetiredIdPanel from '@/components/PidRetiredIdPanel.vue';

export default {
  mixins: [
    NotificationManager,
    PermissionManager,
  ],
  components: {
    DmPendingNearMatchOverview,
    PersonProfilePidPendingNearMatchOverview,
    PersonProfileMasterRecordHighlights,
    PersonProfileRecentNotesOverview,
    PersonProfileAliasIdOverview,
    PersonProfileRecentHistoryOverview,
    PidRetiredIdPanel,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    isRetired: {
      type: Boolean,
      default: false,
    },
    person: {
      type: Object,
      required: true,
    },
    dmNearMatches: {
      type: Array,
      required: true,
    },
    dmNearMatchTotalCount: {
      type: Number,
    },
    pidNearMatches: {
      type: Array,
      required: true,
    },
    pidNearMatchTotalCount: {
      type: Number,
      default: null,
    },
    aliasIds: {
      type: Array,
      required: true,
    },
    recentHistoryRecords: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped>
  .columns
    display: flex
    flex-wrap: wrap
    & .column
      flex: 0 1 33.333%
      box-sizing: border-box
  @media (max-width: 1250px)
    .columns .column
      flex: 0 1 100%
</style>
